import React, { useEffect } from 'react'
import BaseContainer from '../../Common/BaseContainer'
import finishIcon from '../../../assets/img/finishIcon.svg'
import URLS from '../../../config/navigation'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getAccountVerificationLink } from '../../../store/entities/Auth/Auth.actions'
import Button from '../../Common/Buttons/small'
import HelmentComponet from '../../Common/Helmet'
import Toast from '../../Common/Toast'
import ToastMessage from '../../Common/ToastMessage'
const FinishAccountSettings = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const callback = () => {
    Toast(ToastMessage(4), 'success')
    history.push(URLS.PROFILE.DATA)
  }

  const handleGetAccountVerificationLink = () => {
    localStorage.removeItem('onBoarding')
    dispatch(getAccountVerificationLink({ callback }))
  }

  return (

      <BaseContainer
        additionClass={'public-link preview-connect'}
        title={"There's just one more step..."}
        style={{ width: "53em" }}
      >
        <HelmentComponet title={'Last Step - Connect - TeachOn'} />
        
          <p className={'description BODY_MEDIUM'} style={{marginTop: '0'}}>
            Now that you’ve connected your Stripe account, please <a href="https://dashboard.stripe.com/login">log in to your
            Stripe account</a>. If you are notified that you need to verify your tax
            information, click on the banner and fill in the available fields
            with the following information:
          </p>
            <ul className={'BODY_MEDIUM'}>
              <li>
                <span className={'EMPHASIS_MEDIUM'}>Type of business:</span>{' '}
                Individual, sole proprietor, or single-member LLC
              </li>
              <li>
                <span className={'EMPHASIS_MEDIUM'}>Blank Field:</span> Full name
              </li>
              <li>
                <span className={'EMPHASIS_MEDIUM'}>
                  Tax Identification Number:
                </span>{' '}
                Social Security Number
              </li>
            </ul>
            <p className={'BODY_MEDIUM'}>
              After that, please go to the <a href="https://dashboard.stripe.com/settings/payments">payment methods page</a>. Request access to
              both WeChat Pay and Alipay. Initially, these methods will show as
              ‘pending’. That’s okay! They should be enabled soon.
            </p>
            <br/>
            <p className={'BODY_MEDIUM'}>
              Once one or both of your payment methods have been activated you can
              start accepting payments.
            </p>
            <br/>
          <Button
            handleClick={handleGetAccountVerificationLink}
            loading={false}
            additionClass={'BUTTON_MEDIUM mt-32'}
            text={'Continue to my profile'}
          />
      </BaseContainer>

  )
}

export default FinishAccountSettings
